const Item = () => (
  <span className="mx-8 inline-flex items-center gap-8">
    <span>Bold Moves Build Real Growth</span>
    <span className="text-[#C6FF00]">✦</span>
  </span>
);

export const Marquee = ({ reverse = false }) => (
  <div
    className="relative w-full overflow-hidden border-y border-[#2A2D34] bg-[#0A0C0F] py-6"
    data-testid="marquee"
  >
    <div
      className={`marquee-mask flex whitespace-nowrap text-4xl md:text-6xl font-black uppercase tracking-tighter text-white/90 ${
        reverse ? "marquee-slow" : "animate-marquee"
      }`}
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <Item key={`marquee-copy-${i}`} />
      ))}
    </div>
  </div>
);
